import { useEffect, useState } from "react";
import { useAppServices } from "../../../../../../hook/services";
import DataTable from "../../../components/DataTable";
import AddFieldModal from "./AddFieldModal";
import Swal from "sweetalert2";

const FormFieldsTab = ({ app, handleRefresh }) => {
  const AppService = useAppServices();
  const [formFields, setFormFields] = useState(app?.formFields || []);
  useEffect(() => {
    setFormFields(app?.formFields || []);
  }, [app]);
  const handleDelete = async (removeIndex) => {
    const result = await Swal.fire({
      title: "Delete Field?",
      text: "This field will be removed from the app",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      // Remove object using slice
      let formFieldsData = [
        ...formFields.slice(0, removeIndex),
        ...formFields.slice(removeIndex + 1),
      ];

      const payload = {
        _id: app._id,
        formFields: formFieldsData,
      };

      const { response } = await AppService.apps.update({ payload });
      if (response) {
        handleRefresh();
        Swal.fire("Deleted!", "Field has been removed.", "success");
      }
    }
  };

  const columns = [
    { label: "Label", accessor: "label" },
    { label: "Key", accessor: "key" },
    { label: "Short Description", accessor: "short_description" },
    {
      label: "Actions",
      accessor: "actions",
      renderCell: (row, index) => (
        <div className="d-flex gap-2">
          <AddFieldModal
            initialData={row}
            app={app}
            updateIndex={index}
            handleRefresh={handleRefresh}
          />
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(index)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <AddFieldModal handleRefresh={handleRefresh} app={app} />
      </div>
      <DataTable columns={columns} data={formFields} entriesPerPage={10} />
    </div>
  );
};

export default FormFieldsTab;
